import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=321f9fba&scoped=true"
import script from "./BarCharts.vue?vue&type=script&lang=ts"
export * from "./BarCharts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f9fba",
  null
  
)

export default component.exports